module.exports = __webpack_public_path__ + "static/media/superman-profile.9f15fc8a.jpg";